import { render, staticRenderFns } from "./terminos_y.vue?vue&type=template&id=491a05b0"
import script from "./terminos_y.vue?vue&type=script&lang=js"
export * from "./terminos_y.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports